import List from './VerticalScrollList';
import ListItem from './VerticalScrollListItem';

export default { List, ListItem };
